import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginForm from './AuthPages/Login';
import CraneDashboard from './Pages/dashboard';
import CraneSubDashboard from './Pages/subdashboard';
import OperationsLog from './Pages/operationslog';
import Load from './Pages/load';
import DefaultLayout from './Layout/Defaultlayout';
import ProtectedRoute from './ProtectedRoute';
import EnergyMonitoring from './Pages/energymonitoring';
import MachineManagement from './Pages/machine';
import MachineConfig from './Pages/machine-form';
import RemoteAlarms from './Pages/remote';
import UserManagement from './Pages/user';
import DeviceManagement from './Pages/device';
import BrakeMonitoring from './Pages/break';
import CraneZoneMonitoring from './Pages/zone';
import VibrationMonitoring from './Pages/vibration';
import TemperatureMonitoring from './Pages/temperature';
import ErrorLog from './Pages/errors';
import Reports from './Pages/reports';
import Alerts from './Pages/alerts';
import Help from './Pages/help';
import Signup from './AuthPages/SignupPage';
import CreatePassword from './AuthPages/CreatePassword';
import Approval from './AuthPages/Approval';
import ResetPassword from './AuthPages/ResetPassword';
import ForgotPassword from './AuthPages/ForgotPassword';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const RoutesComponent = () => {
  return (
    <Suspense fallback={loading}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/create-password" element={<CreatePassword />} />
        <Route path="/approval" element={<Approval />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        
        {/* Protected routes with layout */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DefaultLayout />}>
            <Route path="/dashboard" element={<CraneDashboard />} />
            <Route path="/subdashboard" element={<CraneSubDashboard />} />
            <Route path="/operationslog" element={<OperationsLog />} />
            <Route path="/load" element={<Load />} />
            <Route path="/energy-monitoring" element={<EnergyMonitoring />} />
            <Route path="/machine/edit/:id" element={<MachineConfig />} />
            <Route path="/machine/add" element={<MachineConfig />} />
            <Route path="/machine" element={<MachineManagement />} />
            <Route path="/remote" element={<RemoteAlarms />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/device" element={<DeviceManagement />} />
            <Route path="/brake" element={<BrakeMonitoring />} />
            <Route path="/zone" element={<CraneZoneMonitoring />} />
            <Route path="/vibration-monitoring" element={<VibrationMonitoring />} />
            <Route path="/temperature" element={<TemperatureMonitoring />} />
            <Route path="/error-log" element={<ErrorLog />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/help" element={<Help />} />
          </Route>
        </Route>
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;